/**
 * Mixin for the SINGLE item select attributes.
 * @type {{methods: {
 *    _isIE: mixin.methods._isIE
 *    _debounceChange: mixin.methods._debounceChange
 *    _onChange: mixin.methods._onChange
 *    _sendChangeEvent: mixin.methods._sendChangeEvent
 *    } }}
 */
import debounce from "lodash/debounce";

const mixin = {
  methods: {
    /**
     * Check if this browser is IE.
     * @returns {boolean} If this is IE.
     * @private
     */
    _isIE: function () {
      return /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.test(navigator.userAgent);
    },

    /**
     * Debounce function for the onchange event. This should be used with IE.
     * @private
     */
    _debounceChange: debounce((self, value, text) => {
      self._sendChangeEvent(value, text);
    }, 250), // When IE we debounce for 250ms to loads of updates when navigating a select

    /**
     * Handler for the onChange event on the select. This will organise calling
     * debounce or not.
     * This needs to handle being called with (value,text) or just the (event).
     * @private
     */
    _onChange: function (event, textParam) {
      var value = event;
      var text = textParam;

      if (event && event.target) {
        value = event.target.value;
        text =
          event.target.selectedIndex > -1
            ? event.target.options[event.target.selectedIndex].text
            : "";
      }
      if (this._isIE()) {
        // We debounce this change because in IE it will change on every arrow key press
        this._debounceChange(this, value, text);
      } else {
        this._sendChangeEvent(value, text);
      }
    },

    /**
     * Send the actual event. This can be overridden to send different information.
     * @private
     */
    _sendChangeEvent: function (value, text) {
      this.$emit("ui-change", {
        value: this.model,
        id: this.id ? this.id : "",
        el: this.$el,
        text: text
      });
    }
  }
};

export default mixin;
